import { useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { selectUser } from '../../features/auth/authSlice';
import { Flex } from '../../commonStyles';
import { IStatus } from '../../types/project';
import { IUnit } from '../../types/unit';
import { selectProject } from '../../features/project/projectSlice';
import { unitStatusTitles } from '../../utils/Constants';
import { PriceGridContext } from '../../context/PriceGridContext';

const Legend = (props: any) => {
  const { units, legend, setSelectingUnits, setSelectedUnits } = props;
  const user = useSelector(selectUser);
  const project = useSelector(selectProject);
  const [selectedStatus, setSelectedStatus] = useState<string>('');
  const { leasing } = useContext(PriceGridContext);

  let allStatus: IStatus[] = leasing
    ? [
        ...project.status.filter((status: IStatus) => status.type === 'leasing'),
        ...unitStatusTitles.filter((status: IStatus) => status.type === 'leasing'),
      ]
    : [
        ...project.status.filter((status: IStatus) => status.type === 'preconstruction'),
        ...unitStatusTitles.filter((status: IStatus) => status.type === 'preconstruction'),
      ];

  const countAllStatuses = (code: string) => {
    if (leasing) {
      return units.filter((unit: IUnit) => unit.leaseStatus === code).length;
    } else {
      return units.filter((unit: IUnit) => unit.status === code).length;
    }
  };

  const filterStatuses = (code: string) => {
    if (selectedStatus === code) {
      setSelectedStatus('');
      setSelectedUnits([]);
      setSelectingUnits(false);
    } else {
      setSelectingUnits(true);
      setSelectedStatus(code);
      if (leasing) {
        setSelectedUnits(units.filter((unit: IUnit) => unit.leaseStatus === code).map((unit: IUnit) => unit));
      } else {
        setSelectedUnits(units.filter((unit: IUnit) => unit.status === code).map((unit: IUnit) => unit));
      }
    }
  };

  return (
    <Box>
      {user.type !== 'Sales' && legend ? (
        <Flex
          sx={{
            flexWrap: 'wrap',
            mr: 2,
            my: 2,
            '@media (max-width: 600px)': {
              display: 'none',
            },
            '@media (max-width:1499.98px)': {
              mr: 1.5,
              my: 1,
              fontSize: '10px',
            },
          }}
        >
          {allStatus.map((status, index) => {
            return (
              <Flex
                onClick={() => filterStatuses(status.code)}
                sx={{
                  mr: 2,
                  mt: 1,
                  cursor: 'pointer',
                  '@media (max-width:1499.98px)': {
                    mr: 1.5,
                    mt: 0.5,
                  },
                }}
                key={index}
              >
                <Box
                  sx={{
                    width: '20px',
                    height: '10px',
                    border: '1px solid #000',
                    alignSelf: 'center',
                    mr: 1,
                    backgroundColor: status.color,
                    '@media (max-width:1499.98px)': {
                      width: '16px',
                      height: '8px',
                      mr: 0.5,
                    },
                  }}
                ></Box>
                <Box sx={{ alignSelf: 'center', fontWeight: selectedStatus === status.code ? 700 : 400 }}>{status.name}</Box>
                <Box sx={{ alignSelf: 'center', fontWeight: selectedStatus === status.code ? 700 : 400 }}>
                  ({countAllStatuses(status.code)})
                </Box>
              </Flex>
            );
          })}
        </Flex>
      ) : null}
    </Box>
  );
};

export default Legend;
